import { createTheme } from '@mui/material/styles';

import darkPalette from './darkPalette';
import lightPalette from './lightPalette';
import typography from './typography';
import '@fontsource/lato';

const lightTheme = createTheme({
  palette: lightPalette,
  typography: {
    fontFamily: typography.fontFamily,
    fontSize: 14,
    special: {
      fontFamily: typography.orderSummaryFontFamily
    }
  }
});
const darkTheme = createTheme({
  palette: darkPalette,

  typography: {
    fontFamily: typography.fontFamily,
    fontSize: 14,
    special: {
      fontFamily: typography.orderSummaryFontFamily
    }
  }
});

export { lightTheme, darkTheme };
